<template>
  <v-container>
    <h1>PESQUISA</h1>
    <v-row>
      <v-col cols="12" md="7">
        <h3>Apresentação</h3>
        <p class="text">
          O Observatório nas escolas é um sistema de acompanhamento dos
          indicadores de C&T das escolas do estado do Amapá, que apresenta dados
          quantitativos por município e escolas, a fim de fornecer subsídios
          para os gestores e a população acompanharem a coleta de dados no Censo
          Escolar.
        </p>
        <h3>Objetivo</h3>
        <p class="text">
          A pesquisa entrevista gestores da comunidade escolar e se propõe a
          avaliar indicadores de produtos e serviços de ciência e tecnologia
          utilizados e disponíveis nas escolas públicas do estado do Amapá, para
          mapear o acesso, o uso e a apropriação das tecnologias de informação e
          comunicação (TIC) em escolas públicas de educação básica. Por fim a
          desenvolver uma plataforma web que tem por objetivo disponibilizar
          indicadores possibilitará a avaliação de indicadores para tomadas de
          decisões estratégicas.
        </p>
        <h3>Metodologia</h3>
        <p class="text">
          A abrangência da pesquisa considera as escolas públicas estaduais.
          Para a seleção da amostra foi utilizado questionário aplicado as 392
          escolas urbanas e rurais nos 16 municípios do estado do Amapá das
          quais 72,7% (285) escolas responderam, o questionário foi aplicado no
          mês de julho de 2020 e como proposta esperamos que esses dados sejam
          norteadores a criação de políticas públicas e tomada de decisões
          estratégicas por parte da gestão, o intuito é que esta pesquisa seja
          aplicada anualmente na atualização da base de dados. A plataforma será
          desenvolvida e hospedada em um ambiente web para que os gestores e
          diretores das escolas públicas cadastrem as informações e fique
          disponível para acesso público, oportunizando consultas e a emissão de
          relatórios.
        </p>
      </v-col>
      <v-col cols="12" md="5" align-self="center">
        <v-row wrap>
          <v-col v-for="i in indicators.length" :key="i" cols="12" sm="6">
            <Counter
              :title="indicators[i - 1].name"
              :value="indicators[i - 1].qtd"
              :icon="indicators[i - 1].icon"
              :isBig="true"
              :percent="i > 3"
            />
          </v-col>
          <v-col> * Dados do Censo Escolar 2020 - INEP </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Counter from "./counter.vue";

export default {
  name: "search",
  components: {
    Counter,
  },
  data() {
    return {
      indicators: [
        {
          name: "Escolas",
          qtd: 858,
          icon: "mdi-domain",
        },
        {
          name: "Discentes",
          qtd: 219299,
          icon: "mdi-school",
        },
        {
          name: "Docentes",
          qtd: 11139,
          icon: "mdi-grease-pencil",
        },
        {
          name: "Salas de TI",
          qtd: 32,
          icon: "mdi-desktop-classic",
        },
        {
          name: "Biblioteca",
          qtd: 27,
          icon: "mdi-library",
        },
        {
          name: "Internet",
          qtd: 40,
          icon: "mdi-microsoft-internet-explorer",
        },
      ],
    };
  },
};
</script>

<style scoped>
.text {
  text-indent: 40px;
  text-align: justify;
}
</style>